<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="1180" persistent>
      <v-card>
        <v-card-title class="text-h5 blue darken-3 white--text">
          Dashboard academico
        </v-card-title>

        <v-card-text class="dashboard-academico">
          <v-progress-linear
            v-if="loading"
            color="green accent-3"
            indeterminate
            height="4"
            rounded
            class="mt-2"></v-progress-linear>

          <v-tabs v-if="!loading" v-model="tab" class="mt-2" grow>
            <v-tab>Resumen</v-tab>
            <v-tab>Informe por sede</v-tab>
          </v-tabs>

          <v-tabs-items v-if="!loading" v-model="tab">
            <v-tab-item>
          <div class="text-left">
            <b>NOTA: Los estados de inscripciones no se usa los nuevos estados administrativos de los estudiantes (en un futuro se actualizara a estos)</b>
            <v-row v-if="programas.length > 0" dense class="mt-3">
              <v-col cols="12" sm="6" md="3">
                <div class="dash-resumen">
                  <small>Total programas</small>
                  <strong>{{ dashboardFiltrado.totales.programas }}</strong>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <div class="dash-resumen">
                  <small>Pre inscritos</small>
                  <strong>{{ dashboardFiltrado.totales.preinscritos }}</strong>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <div class="dash-resumen">
                  <small>Inscritos</small>
                  <strong>{{ dashboardFiltrado.totales.inscritos }}</strong>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <div class="dash-resumen">
                  <small>Otros estados</small>
                  <strong>{{ dashboardFiltrado.totales.otros }}</strong>
                </div>
              </v-col>
            </v-row>

            <v-row dense class="mt-2">
              <v-col cols="12" sm="6" md="2">
                <v-select
                  v-model="filtros.gestion"
                  :items="gestiones"
                  label="Gestion"
                  :disabled="loading"
                  dense
                  outlined
                  hide-details
                  @change="recargarDatos"></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-select
                  v-model="filtros.mesInforme"
                  :items="mesesInforme"
                  item-text="nombre"
                  item-value="valor"
                  label="Mes"
                  dense
                  outlined
                  clearable
                  hide-details></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-select
                  v-model="filtros.universidad"
                  :items="opcionesUniversidad"
                  item-text="nombre"
                  item-value="key"
                  label="Universidad"
                  dense
                  outlined
                  clearable
                  hide-details></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-autocomplete
                  v-model="filtros.sede"
                  :items="opcionesSede"
                  item-text="nombre"
                  item-value="key"
                  label="Sede"
                  :menu-props="{ maxHeight: 320 }"
                  dense
                  outlined
                  clearable
                  hide-details></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-select
                  v-model="filtros.fase"
                  :items="opcionesFase"
                  item-text="nombre"
                  item-value="key"
                  label="Fase"
                  dense
                  outlined
                  clearable
                  hide-details></v-select>
              </v-col>
            </v-row>

            <p v-if="programas.length == 0" class="mt-3 mb-0">
              No se encontraron programas para la gestion seleccionada.
            </p>

            <div v-if="programas.length > 0 && programasFiltrados.length !== programas.length" class="mt-3">
              <p class="mb-1">
                <b>{{ programasFiltrados.length }}</b> programas encontrados con los filtros seleccionados.
              </p>
              <div class="programas-lista">
                <div v-for="(programa, index) in programasFiltrados" :key="programa.id" class="programa-linea">
                  <span class="programa-numero green--text">{{ index + 1 }}.</span>
                  <b>{{ programa.codigo || programa.id }}</b>
                  {{ programa.nombre_compuesto }}
                  <small>
                    | {{ nombreSede(programa) }} | {{ nombreUniversidad(programa) }} | {{ modalidadTexto(programa.modalidad) }}
                  </small>
                </div>
              </div>
            </div>

            <h4 v-if="programas.length > 0" class="mt-4 mb-2">Resumen por sede</h4>
            <div v-if="programas.length > 0" class="table-responsive">
              <table class="table table-condensed table-striped table-hover dash-table">
                <thead>
                  <tr>
                    <th class="col-sede">Sede</th>
                    <th class="text-right col-numero">Programas</th>
                    <th class="text-right col-inscripcion">Pre inscritos</th>
                    <th class="text-right col-inscripcion">Inscritos</th>
                    <th class="text-right col-inscripcion">Otros</th>
                    <th class="col-academico">Categoria</th>
                    <th class="col-academico">Area</th>
                    <th class="col-programa">Modalidad</th>
                    <th class="col-programa">Fase</th>
                    <th class="col-universidad">Universidad</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="sede in dashboardFiltrado.sedes" :key="sede.key">
                    <td class="col-sede">{{ sede.nombre }}</td>
                    <td class="text-right col-numero">{{ sede.programas }}</td>
                    <td class="text-right col-inscripcion">{{ sede.preinscritos }}</td>
                    <td class="text-right col-inscripcion">{{ sede.inscritos }}</td>
                    <td class="text-right col-inscripcion">{{ sede.otros }}</td>
                    <td class="col-academico">{{ resumenConteo(sede.categorias) }}</td>
                    <td class="col-academico">{{ resumenConteo(sede.areas) }}</td>
                    <td class="col-programa">{{ resumenConteo(sede.modalidades) }}</td>
                    <td class="col-programa">{{ resumenConteo(sede.fases) }}</td>
                    <td class="col-universidad">{{ resumenConteo(sede.universidades) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <v-row v-if="programas.length > 0" dense>
              <v-col cols="12" md="6">
                <h4 class="mt-3 mb-2">Postgrado > Categoria</h4>
                <div class="table-responsive">
                  <table class="table table-condensed table-striped dash-table">
                    <thead>
                      <tr>
                        <th>Categoria</th>
                        <th class="text-right">Programas</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in dashboardFiltrado.categorias" :key="item.key">
                        <td>{{ item.nombre }}</td>
                        <td class="text-right">{{ item.cantidad }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-col>

              <v-col cols="12" md="6">
                <h4 class="mt-3 mb-2">Postgrado > Area</h4>
                <div class="table-responsive">
                  <table class="table table-condensed table-striped dash-table">
                    <thead>
                      <tr>
                        <th>Area</th>
                        <th class="text-right">Programas</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in dashboardFiltrado.areas" :key="item.key">
                        <td>{{ item.nombre }}</td>
                        <td class="text-right">{{ item.cantidad }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-col>
            </v-row>

            <v-row v-if="programas.length > 0" dense>
              <v-col cols="12" md="6">
                <h4 class="mt-3 mb-2">Modalidad</h4>
                <div class="conteo-lista">
                  <div v-for="item in dashboardFiltrado.modalidades" :key="item.key">
                    <b>{{ item.cantidad }}</b> {{ item.nombre }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <h4 class="mt-3 mb-2">Fase</h4>
                <div class="conteo-lista">
                  <div v-for="item in dashboardFiltrado.fases" :key="item.key">
                    <b>{{ item.cantidad }}</b> {{ item.nombre }}
                  </div>
                </div>
              </v-col>
            </v-row>

            <v-row v-if="programas.length > 0" dense>
              <v-col cols="12" md="6">
                <h4 class="mt-3 mb-2">Universidad</h4>
                <div class="conteo-lista">
                  <div v-for="item in dashboardFiltrado.universidades" :key="item.key">
                    <b>{{ item.cantidad }}</b> {{ item.nombre }}
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
            </v-tab-item>

            <v-tab-item>
              <div class="text-left informe-sede">
                <v-row dense class="mt-3">
                  <v-col cols="12" md="3">
                    <v-select
                      v-model="filtros.gestion"
                      :items="gestiones"
                      label="Gestion"
                      :disabled="loading"
                      dense
                      outlined
                      hide-details
                      @change="recargarDatos"></v-select>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select
                      v-model="filtros.mesInforme"
                      :items="mesesInforme"
                      item-text="nombre"
                      item-value="valor"
                      label="Mes"
                      dense
                      outlined
                      clearable
                      hide-details></v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-combobox
                      v-model="filtros.sedeComun"
                      :items="opcionesSedeComun"
                      item-text="nombre"
                      item-value="valor"
                      label="Sede en comun"
                      placeholder="Ej.: Tarija, Camargo, Sucre..."
                      :menu-props="{ maxHeight: 320 }"
                      dense
                      outlined
                      clearable
                      hide-details></v-combobox>
                  </v-col>
                </v-row>

                <p v-if="programas.length == 0" class="mt-3 mb-0">
                  No se encontraron programas para la gestion seleccionada.
                </p>

                <div v-if="programas.length > 0 && !filtros.sedeComun" class="mt-3">
                  Seleccione o escriba una sede en comun para generar el informe.
                </div>

                <div v-if="filtros.sedeComun" class="mt-3">
                  <h4 class="mb-1">Informe de programas academicos: {{ textoSedeComun }}</h4>
                  <p class="mb-2">
                    <b>{{ programasSedeComun.length }}</b> programas encontrados en {{ nombreMesInforme }}.
                    <span v-if="sedesSedeComun.length > 0">
                      Sedes: {{ sedesSedeComun.join(' | ') }}
                    </span>
                  </p>

                  <p v-if="programasSedeComun.length == 0" class="mb-0">
                    No se encontraron programas con esa sede en comun.
                  </p>

                  <div
                    v-for="grupo in informeSedeComun"
                    :key="grupo.key"
                    class="informe-universidad">
                    <div class="informe-universidad-titulo">
                      {{ grupo.nombre }}
                    </div>

                    <div class="table-responsive">
                      <table class="table table-condensed informe-table">
                        <thead>
                          <tr>
                            <th>Programa academico</th>
                            <th class="text-right">Inscritos</th>
                            <th>Estado / Fase</th>
                            <th class="text-right">Pre inscritos</th>
                            <th class="text-right">Otros</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="programa in grupo.programas" :key="programa.id">
                            <td>
                              <b>{{ programa.nombre_compuesto }}</b>
                              <small>{{ programa.codigo || programa.id }} | {{ nombreSede(programa) }}</small>
                            </td>
                            <td class="text-right inscritos">{{ programa.inscritos }}</td>
                            <td>{{ getFase(programa.fase) }}</td>
                            <td class="text-right">{{ programa.preinscritos }}</td>
                            <td class="text-right">{{ programa.otros }}</td>
                          </tr>
                          <tr class="informe-subtotal">
                            <td>Subtotal inscritos</td>
                            <td class="text-right">{{ grupo.totalInscritos }}</td>
                            <td></td>
                            <td class="text-right">{{ grupo.totalPreinscritos }}</td>
                            <td class="text-right">{{ grupo.totalOtros }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>

        <v-card-actions>
          <v-btn
            v-if="$store.state.CARGO.id == -1"
            color="green"
            outlined
            :disabled="programas.length == 0"
            :loading="exportandoExcel"
            @click="descargarExcelGestion">
            Descargar Excel gestion
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="cerrar()"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
  
<script>
import gql from 'graphql-tag';
import { exportarInscripcionesPorPrograma } from './ver_dashboard';

const SIN_SEDE = 'Sin sede';
const SIN_UNIVERSIDAD = 'Sin universidad';
const SIN_CATEGORIA = 'Sin categoria';
const SIN_AREA = 'Sin area';
const SIN_MODALIDAD = 'Sin modalidad';
const SEDES_COMUNES = [
    { valor: 'tarija', nombre: 'Tarija' },
    { valor: 'sucre', nombre: 'Sucre' },
    { valor: 'potosi', nombre: 'Potosi' },
    { valor: 'santa cruz', nombre: 'Santa Cruz' },
    { valor: 'yacuiba', nombre: 'Yacuiba' },
    { valor: 'camargo', nombre: 'Camargo' },
    { valor: 'cochabamba', nombre: 'Cochabamba' },
    { valor: 'la paz', nombre: 'La Paz' },
    { valor: 'latam', nombre: 'Latam' },
    { valor: 'monteagudo', nombre: 'Monteagudo' },
    { valor: 'cobija', nombre: 'Cobija' },
];

const dashboardVacio = () => ({
    totales: {
        programas: 0,
        preinscritos: 0,
        inscritos: 0,
        otros: 0,
    },
    sedes: [],
    categorias: [],
    areas: [],
    modalidades: [],
    fases: [],
    universidades: [],
});

export default {
    data() {
        const anioActual = new Date().getFullYear();
        const mesActual = new Date().getMonth() + 1;

        return { 
            tab: 0,
            dialog: false, 
            loading: false, 
            exportandoExcel: false,
            programas: [],
            dashboard: dashboardVacio(),
            gestiones: this.crearGestiones(anioActual),
            mesesInforme: this.crearMesesInforme(),
            filtros: {
                gestion: anioActual,
                universidad: null,
                sede: null,
                fase: null,
                sedeComun: null,
                mesInforme: mesActual,
            },
            resolvePromise: null,
        };
    },
    computed: {
        opcionesUniversidad() {
            return this.dashboard.universidades.map(item => ({
                key: item.key,
                nombre: `${item.nombre} (${item.cantidad})`,
            }));
        },

        opcionesSede() {
            return this.dashboard.sedes.map(item => ({
                key: item.key,
                nombre: `${item.nombre} (${item.programas})`,
            }));
        },

        opcionesFase() {
            return this.dashboard.fases.map(item => ({
                key: item.key,
                nombre: `${item.nombre} (${item.cantidad})`,
            }));
        },

        programasFiltrados() {
            return this.programas.filter(programa => {
                const coincideUniversidad = !this.filtros.universidad || this.keyUniversidad(programa) === this.filtros.universidad;
                const coincideSede = !this.filtros.sede || this.keySede(programa) === this.filtros.sede;
                const coincideFase = !this.filtros.fase || this.keyFase(programa) === this.filtros.fase;

                return coincideUniversidad && coincideSede && coincideFase;
            });
        },

        dashboardFiltrado() {
            return this.crearDashboard(this.programasFiltrados);
        },

        opcionesSedeComun() {
            const conteo = {};
            const sedes = [...new Set(this.programas.map(programa => this.nombreSede(programa)))].sort((a, b) => a.localeCompare(b));

            sedes.forEach(sede => {
                const sedeComun = this.obtenerSedeComunPorNombre(sede);

                if (!conteo[sedeComun.valor]) {
                    conteo[sedeComun.valor] = {
                        valor: sedeComun.valor,
                        nombre: sedeComun.nombre,
                        sedes: new Set(),
                    };
                }

                conteo[sedeComun.valor].sedes.add(sede);
            });

            return Object.values(conteo)
                .sort((a, b) => {
                    return a.nombre.localeCompare(b.nombre);
                })
                .map(item => ({
                    valor: item.valor,
                    nombre: `${item.nombre} (${item.sedes.size})`,
                }));
        },

        sedeComunValor() {
            if (!this.filtros.sedeComun) return '';
            if (typeof this.filtros.sedeComun === 'string') return this.limpiarTextoOpcion(this.filtros.sedeComun);
            return this.limpiarTextoOpcion(this.filtros.sedeComun.valor || this.filtros.sedeComun.nombre || '');
        },

        textoSedeComun() {
            return this.tituloTexto(this.sedeComunValor);
        },

        nombreMesInforme() {
            if (!this.filtros.mesInforme) return 'todos los meses';

            const mes = this.mesesInforme.find(item => item.valor === Number(this.filtros.mesInforme));
            return mes ? mes.nombre : 'el mes seleccionado';
        },

        programasSedeComun() {
            const texto = this.normalizarBusqueda(this.sedeComunValor);

            if (!texto) return [];

            return this.programas.filter(programa => {
                const sedeComun = this.obtenerSedeComunPorNombre(this.nombreSede(programa));
                const coincideSede = sedeComun.valor === texto || this.normalizarBusqueda(this.nombreSede(programa)).includes(texto);
                const coincideMes = !this.filtros.mesInforme || this.obtenerMesFecha(programa.fecha_inicio) === Number(this.filtros.mesInforme);

                return coincideSede && coincideMes;
            });
        },

        sedesSedeComun() {
            return [...new Set(this.programasSedeComun.map(programa => this.nombreSede(programa)))].sort((a, b) => a.localeCompare(b));
        },

        informeSedeComun() {
            const grupos = {};

            this.programasSedeComun.forEach(programa => {
                const key = this.keyUniversidad(programa);
                const nombre = this.nombreUniversidad(programa);
                const inscripciones = this.contarInscripcionesInforme(programa.inscripciones || []);

                if (!grupos[key]) {
                    grupos[key] = {
                        key,
                        nombre,
                        totalInscritos: 0,
                        totalPreinscritos: 0,
                        totalOtros: 0,
                        programas: [],
                    };
                }

                grupos[key].totalInscritos += inscripciones.inscritos;
                grupos[key].totalPreinscritos += inscripciones.preinscritos;
                grupos[key].totalOtros += inscripciones.otros;
                grupos[key].programas.push({
                    ...programa,
                    inscritos: inscripciones.inscritos,
                    preinscritos: inscripciones.preinscritos,
                    otros: inscripciones.otros,
                });
            });

            return Object.values(grupos)
                .map(grupo => ({
                    ...grupo,
                    programas: grupo.programas.sort((a, b) => a.nombre_compuesto.localeCompare(b.nombre_compuesto)),
                }))
                .sort((a, b) => a.nombre.localeCompare(b.nombre));
        },
    },
    methods: {
        async openmodal() {  
          this.dialog = true; 
          this.tab = 0;
          this.programas = [];
          this.dashboard = dashboardVacio();
          this.filtros.gestion = new Date().getFullYear();
          this.filtros.universidad = null;
          this.filtros.sede = null;
          this.filtros.fase = null;
          this.filtros.sedeComun = null;
          this.filtros.mesInforme = new Date().getMonth() + 1;
          const modalPromise = new Promise((resolve) => {
              this.resolvePromise = resolve;
          });

          this.loading = true;
          const jalados = await this.jalarDatos();
          this.loading = false;
          this.programas = jalados;
          this.armar_analiticos(jalados);
          
          return modalPromise;
        }, 

        crearGestiones(anioActual) {
            const gestiones = [];

            for (let gestion = anioActual; gestion >= 2017; gestion -= 1) {
                gestiones.push(gestion);
            }

            return gestiones;
        },

        crearMesesInforme() {
            return [
                { valor: 1, nombre: 'Enero' },
                { valor: 2, nombre: 'Febrero' },
                { valor: 3, nombre: 'Marzo' },
                { valor: 4, nombre: 'Abril' },
                { valor: 5, nombre: 'Mayo' },
                { valor: 6, nombre: 'Junio' },
                { valor: 7, nombre: 'Julio' },
                { valor: 8, nombre: 'Agosto' },
                { valor: 9, nombre: 'Septiembre' },
                { valor: 10, nombre: 'Octubre' },
                { valor: 11, nombre: 'Noviembre' },
                { valor: 12, nombre: 'Diciembre' },
            ];
        },

        async recargarDatos() {
            this.programas = [];
            this.dashboard = dashboardVacio();
            this.filtros.universidad = null;
            this.filtros.sede = null;
            this.filtros.fase = null;
            this.filtros.sedeComun = null;
            this.loading = true;

            const jalados = await this.jalarDatos();

            this.loading = false;
            this.programas = jalados;
            this.armar_analiticos(jalados);
        },

        armar_analiticos(programas){
            this.dashboard = this.crearDashboard(programas);
        },

        descargarExcelGestion() {
            if (this.programas.length == 0 || this.exportandoExcel) return;

            this.exportandoExcel = true;

            try {
                exportarInscripcionesPorPrograma(this.programas, this.filtros.gestion);
            } catch (error) {
                window.console.error('Error al exportar excel del dashboard:', error);
                window.alert('No se pudo generar el archivo Excel.');
            } finally {
                this.exportandoExcel = false;
            }
        },

        crearDashboard(programas) {
            const dashboard = dashboardVacio();
            const sedes = {};
            const categorias = {};
            const areas = {};
            const modalidades = {};
            const fases = {};
            const universidades = {};

            programas.forEach(programa => {
                const inscripciones = this.contarInscripcionesPorGestionMes(programa.inscripciones || []);
                const sedeKey = this.keySede(programa);
                const sedeNombre = this.nombreSede(programa);
                const categoriaKey = this.keyCategoria(programa);
                const categoriaNombre = this.nombreCategoria(programa);
                const areaKey = this.keyArea(programa);
                const areaNombre = this.nombreArea(programa);
                const modalidadKey = this.keyModalidad(programa);
                const modalidadNombre = this.modalidadTexto(programa.modalidad);
                const faseKey = this.keyFase(programa);
                const faseNombre = this.getFase(programa.fase);
                const universidadKey = this.keyUniversidad(programa);
                const universidadNombre = this.nombreUniversidad(programa);

                dashboard.totales.programas += 1;
                dashboard.totales.preinscritos += inscripciones.preinscritos;
                dashboard.totales.inscritos += inscripciones.inscritos;
                dashboard.totales.otros += inscripciones.otros;

                if (!sedes[sedeKey]) {
                    sedes[sedeKey] = {
                        key: sedeKey,
                        nombre: sedeNombre,
                        programas: 0,
                        preinscritos: 0,
                        inscritos: 0,
                        otros: 0,
                        categorias: {},
                        areas: {},
                        modalidades: {},
                        fases: {},
                        universidades: {},
                    };
                }

                sedes[sedeKey].programas += 1;
                sedes[sedeKey].preinscritos += inscripciones.preinscritos;
                sedes[sedeKey].inscritos += inscripciones.inscritos;
                sedes[sedeKey].otros += inscripciones.otros;

                this.sumarConteo(sedes[sedeKey].categorias, categoriaKey, categoriaNombre);
                this.sumarConteo(sedes[sedeKey].areas, areaKey, areaNombre);
                this.sumarConteo(sedes[sedeKey].modalidades, modalidadKey, modalidadNombre);
                this.sumarConteo(sedes[sedeKey].fases, faseKey, faseNombre, this.ordenFase(programa.fase));
                this.sumarConteo(sedes[sedeKey].universidades, universidadKey, universidadNombre);
                this.sumarConteo(categorias, categoriaKey, categoriaNombre);
                this.sumarConteo(areas, areaKey, areaNombre);
                this.sumarConteo(modalidades, modalidadKey, modalidadNombre);
                this.sumarConteo(fases, faseKey, faseNombre, this.ordenFase(programa.fase));
                this.sumarConteo(universidades, universidadKey, universidadNombre);
            });

            dashboard.sedes = this.ordenarPorNombre(Object.values(sedes).map(sede => ({
                ...sede,
                categorias: this.ordenarPorCantidad(Object.values(sede.categorias)),
                areas: this.ordenarPorCantidad(Object.values(sede.areas)),
                modalidades: this.ordenarPorCantidad(Object.values(sede.modalidades)),
                fases: this.ordenarPorOrden(Object.values(sede.fases)),
                universidades: this.ordenarPorCantidad(Object.values(sede.universidades)),
            })));
            dashboard.categorias = this.ordenarPorCantidad(Object.values(categorias));
            dashboard.areas = this.ordenarPorCantidad(Object.values(areas));
            dashboard.modalidades = this.ordenarPorCantidad(Object.values(modalidades));
            dashboard.fases = this.ordenarPorOrden(Object.values(fases));
            dashboard.universidades = this.ordenarPorCantidad(Object.values(universidades));

            return dashboard;
        },

        sumarConteo(destino, key, nombre, orden = null) {
            if (!destino[key]) {
                destino[key] = {
                    key,
                    nombre,
                    cantidad: 0,
                    orden,
                };
            }

            destino[key].cantidad += 1;
        },

        contarInscripciones(inscripciones) {
            return inscripciones.reduce((total, inscripcion) => {
                const estado = inscripcion.estado_ins;

                if (estado === 0 || estado === '0') total.preinscritos += 1;
                else if (estado === 1 || estado === '1') total.inscritos += 1;
                else total.otros += 1;

                return total;
            }, {
                preinscritos: 0,
                inscritos: 0,
                otros: 0,
            });
        },

        contarInscripcionesInforme(inscripciones) {
            return this.contarInscripcionesPorGestionMes(inscripciones);
        },

        contarInscripcionesPorGestionMes(inscripciones) {
            const gestion = Number(this.filtros.gestion);
            const mes = this.filtros.mesInforme ? Number(this.filtros.mesInforme) : null;
            const filtradas = inscripciones.filter(inscripcion => {
                const fecha = this.obtenerPartesFechaRegistro(inscripcion.fecha_registro);

                if (!fecha || fecha.anio !== gestion) return false;
                if (!mes) return true;

                return fecha.mes === mes;
            });

            return this.contarInscripciones(filtradas);
        },

        ordenarPorCantidad(items) {
            return items.sort((a, b) => {
                if (b.cantidad !== a.cantidad) return b.cantidad - a.cantidad;
                return a.nombre.localeCompare(b.nombre);
            });
        },

        ordenarPorNombre(items) {
            return items.sort((a, b) => a.nombre.localeCompare(b.nombre));
        },

        ordenarPorOrden(items) {
            return items.sort((a, b) => {
                if (a.orden !== b.orden) return a.orden - b.orden;
                return a.nombre.localeCompare(b.nombre);
            });
        },

        resumenConteo(items) {
            if (!items || items.length == 0) return '-';

            return items.map(item => `${item.nombre}: ${item.cantidad}`).join(' | ');
        },

        keySede(programa) {
            return programa.sede && programa.sede.id ? `sede-${programa.sede.id}` : 'sede-null';
        },

        nombreSede(programa) {
            return programa.sede && programa.sede.nombre ? programa.sede.nombre : SIN_SEDE;
        },

        keyUniversidad(programa) {
            return programa.universidad && programa.universidad.id ? `universidad-${programa.universidad.id}` : 'universidad-null';
        },

        nombreUniversidad(programa) {
            return programa.universidad && programa.universidad.nombre ? programa.universidad.nombre : SIN_UNIVERSIDAD;
        },

        keyCategoria(programa) {
            return `categoria-${this.normalizarNombreConteo(this.nombreCategoria(programa), SIN_CATEGORIA)}`;
        },

        nombreCategoria(programa) {
            const categoria = programa.postgrado && programa.postgrado.categoria;
            return categoria && categoria.nombre ? categoria.nombre : SIN_CATEGORIA;
        },

        keyArea(programa) {
            return `area-${this.normalizarNombreConteo(this.nombreArea(programa), SIN_AREA)}`;
        },

        nombreArea(programa) {
            const area = programa.postgrado && programa.postgrado.area;
            return area && area.nombre ? area.nombre : SIN_AREA;
        },

        normalizarNombreConteo(nombre, fallback) {
            const texto = nombre || fallback;

            return texto
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/\s+/g, ' ')
                .trim()
                .toLowerCase();
        },

        normalizarBusqueda(texto) {
            return (texto || '')
                .toString()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/[^a-zA-Z0-9\s]/g, ' ')
                .replace(/\s+/g, ' ')
                .trim()
                .toLowerCase();
        },

        tituloTexto(texto) {
            const limpio = this.normalizarBusqueda(texto);

            if (!limpio) return '';

            return limpio
                .split(' ')
                .map(palabra => palabra.charAt(0).toUpperCase() + palabra.slice(1))
                .join(' ');
        },

        limpiarTextoOpcion(texto) {
            return (texto || '').toString().replace(/\s+\(\d+\)$/, '');
        },

        obtenerSedeComunPorNombre(nombreSede) {
            const sedeNormalizada = this.normalizarBusqueda(nombreSede);
            const sedeComun = SEDES_COMUNES.find(item => sedeNormalizada.includes(item.valor));

            if (sedeComun) return sedeComun;

            return {
                valor: sedeNormalizada,
                nombre: nombreSede || SIN_SEDE,
            };
        },

        obtenerMesFecha(fecha) {
            if (!fecha) return null;

            const partes = fecha.split('-');

            if (partes.length < 2) return null;

            const mes = Number(partes[1]);

            return Number.isInteger(mes) ? mes : null;
        },

        obtenerPartesFechaRegistro(fechaRegistro) {
            if (!fechaRegistro) return null;

            const partes = fechaRegistro.split('T')[0].split('-');

            if (partes.length < 2) return null;

            const anio = Number(partes[0]);
            const mes = Number(partes[1]);

            if (!Number.isInteger(anio) || !Number.isInteger(mes)) return null;

            return { anio, mes };
        },

        keyModalidad(programa) {
            return programa.modalidad ? `modalidad-${programa.modalidad}` : 'modalidad-null';
        },

        modalidadTexto(modalidad) {
            const modalidades = {
                P: 'Presencial',
                V: 'Virtual',
                S: 'Semipresencial',
                E: 'E-learning',
            };

            return modalidad ? (modalidades[modalidad] || modalidad) : SIN_MODALIDAD;
        },

        keyFase(programa) {
            return `fase-${programa.fase}`;
        },

        ordenFase(fase) {
            const numero = Number(fase);
            return Number.isNaN(numero) ? 999 : numero;
        },

        getFase(fase) {
            if (fase == 0) return 'NO APROBADO';
            else if (fase == 1) return 'INSCRIPCIONES';
            else if (fase == 2) return 'EN DESARROLLO';
            else if (fase == 3) return 'CONCLUIDO';
            else if (fase == 4) return 'ELABORACION TRABAJOS FINALES';
            else if (fase == 5) return 'RECEPCION DE REQUISITOS DE TITULACION';
            else if (fase == 6) return 'ARMADO CARPETAS';
            else if (fase == 7) return 'PAGO ARANCELES';
            else if (fase == 8) return 'PROCESO TITULACION';
            else if (fase == 9) return 'CERTIFICADOS ENTREGADOS';
            else if (fase == 10) return 'NO EJECUTADO';
            else return 'DESCONOCIDO: ' + fase;
        },

        async jalarDatos() {
            const datos = this.$store.state.CARGOS || [];

            const ids = [...new Set(
                datos
                    .map(item => Number(item.idsede))
                    .filter(id => Number.isInteger(id))
            )];

            const gestion = this.filtros.gestion || new Date().getFullYear();
            const chunkSize = 50;

            const fields = `
                {
                    programa_modulos {
                        id
                        idmodulo
                        iddocente
                        idprograma
                        course_id
                        inicio
                        fin
                        programa {
                            id
                            nombre_compuesto
                            plataforma_id
                        }
                        modulo {
                            id
                            sigla
                            nombre
                        }
                        docente {
                            id
                            email
                            num_doc
                            nombres
                            pri_apellido
                            seg_apellido
                            usuario_moodle
                            clave_moodle
                            telefono1
                        }
                        estado
                    }
                    id
                    plataforma_id
                    course_category_id
                    fase
                    modalidad
                    version
                    grupo
                    arte
                    fecha_inicio
                    fecha_fin
                    fecha_matriculacion
                    gestion
                    mod_finalizado
                    sucursal_id
                    estado
                    inscripciones {
                        id
                        estado_ins
                        estado_administrativo_id
                        fecha_registro
                        ## estudiante{ num_doc nombres pri_apellido seg_apellido telefono1 telefono2 email }
                    }
                    sede {
                        id
                        nombre
                        unidad_negocio
                    }
                    universidad {
                        id
                        nombre
                    }
                    codigo
                    nombre_compuesto
                    postgrado {
                        id
                        nombre
                        area {
                            id
                            nombre
                        }
                        categoria {
                            id
                            nombre
                        }
                    }
                    programa_universidad_id
                    programa_universidad {
                        id
                        codigo
                    }
                    es_programa_regularizado
                }
            `;

            const dividirEnGrupos = (array, size) => {
                const grupos = [];

                for (let i = 0; i < array.length; i += size) {
                    grupos.push(array.slice(i, i + size));
                }

                return grupos;
            };

            const grupos = dividirEnGrupos(ids, chunkSize);

            let programas = []; 

            try {
                for (const grupo of grupos) {
                    const queries = grupo.map(id => `
                        sede_${id}: getProgramas(
                            cursor: 1000000,
                            estado: true,
                            idsede: ${id},
                            gestion: ${gestion}
                        ) ${fields}
                    `).join("\n");

                    const sql = gql`
                        query {
                            ${queries}
                        }
                    `;

                    const { data } = await this.$apollo.query({
                        query: sql,
                        fetchPolicy: "network-only"
                    });

                    programas = programas.concat(Object.values(data).flat());
                }

                /* window.console.log("IDs sedes:", ids);
                window.console.log("Total sedes:", ids.length);
                window.console.log("Total grupos:", grupos.length);
                window.console.log("Programas unidos:", programas); */

                return programas;
            } catch (e) {
                window.console.error("Error al jalar programas:", e);
                return programas;
            }
        },

        cerrar(){
          if (this.resolvePromise) this.resolvePromise(false);
          this.dialog = false;
        }, 
    }
};
</script>

<style scoped>
.dashboard-academico {
    max-height: 76vh;
    overflow-y: auto;
}

.dash-resumen {
    border: 1px solid #d9e2ec;
    border-radius: 6px;
    padding: 10px 12px;
    background: #fff;
}

.dash-resumen small {
    display: block;
    color: #52616b;
}

.dash-resumen strong {
    display: block;
    font-size: 24px;
    line-height: 1.2;
}

.dash-table {
    font-size: 12px;
    border-collapse: separate;
    border-spacing: 0;
}

.dash-table th {
    background: #196391;
    color: #fff;
    border-right: 1px solid rgba(255, 255, 255, 0.28);
    vertical-align: middle;
    white-space: nowrap;
}

.dash-table th:last-child {
    border-right: 0;
}

.dash-table td {
    border-right: 1px solid #d9e2ec;
    border-bottom: 1px solid #d9e2ec;
    vertical-align: top;
}

.dash-table td:last-child {
    border-right: 0;
}

.dash-table .col-sede {
    min-width: 150px;
    font-weight: 600;
}

.dash-table .col-numero {
    min-width: 82px;
    background: #f7fafc;
    color: black;
    font-weight: 600;
}

.dash-table .col-inscripcion {
    min-width: 92px;
    background: #f3f8ff;
    color: black;
}

.dash-table .col-academico {
    min-width: 180px;
    background: #fffaf0;
    color: black;
}

.dash-table .col-programa {
    min-width: 170px;
    background: #f7fff7;
    color: black;
}

.dash-table .col-universidad {
    min-width: 180px;
    background: #faf5ff;
    color: black;
}

.programas-lista,
.conteo-lista {
    border: 1px solid #d9e2ec;
    border-radius: 6px;
    padding: 8px 10px;
    background: #fff;
}

.programas-lista {
    max-height: 260px;
    overflow-y: auto;
}

.programa-linea {
    padding: 4px 0;
    border-bottom: 1px solid #edf2f7;
}

.programa-linea:last-child {
    border-bottom: 0;
}

.programa-numero {
    display: inline-block;
    min-width: 28px;
    color: #52616b;
    font-weight: 600;
}

.informe-sede {
    min-height: 360px;
}

.informe-universidad {
    border: 1px solid #2f6b56;
    margin-top: 14px;
    background: #fff;
}

.informe-universidad-titulo {
    background: #173f67;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0;
    padding: 6px 10px;
    text-align: center;
    text-transform: uppercase;
}

.informe-table {
    font-size: 12px;
    margin-bottom: 0;
}

.informe-table th {
    background: #315a22;
    color: #fff;
    border-right: 1px solid rgba(255, 255, 255, 0.35);
    text-transform: uppercase;
    vertical-align: middle;
}

.informe-table td {
    border-right: 1px solid #cfd8dc;
    border-bottom: 1px solid #cfd8dc;
    vertical-align: top;
}

.informe-table td small {
    display: block;
    color: #52616b;
    margin-top: 2px;
}

.informe-table .inscritos {
    background: #d9edf9;
    color: #0b4f7a;
    font-size: 15px;
    font-weight: 700;
}

.informe-subtotal td {
    background: #fff8d8;
    color: #173f67;
    font-weight: 700;
}
</style>
  
